import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WalletProviders } from "@/wallet/WalletProviders";
import { ConnectPage } from "@/pages/Connect";
import { RecoveryPage } from "@/pages/Recovery";
import { PausePage } from "@/pages/Pause";
import { Header } from "@/components/Header";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale by default — operators expect "Refresh" to feel responsive.
      // Per-call hooks override this when something truly is cacheable.
      staleTime: 0,
      gcTime: 30_000,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <WalletProviders>
        <BrowserRouter>
          <div className="min-h-screen">
            <Header />
            <main className="mx-auto max-w-6xl px-6 py-8">
              <Routes>
                <Route path="/" element={<ConnectPage />} />
                <Route path="/recovery" element={<RecoveryPage />} />
                <Route path="/pause" element={<PausePage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      </WalletProviders>
    </QueryClientProvider>
  );
}
